export default __webpack_public_path__ + "static/media/13-bm.3caf3fc6.webp";